import { render, staticRenderFns } from "./editWarning.vue?vue&type=template&id=c7c080f8&scoped=true&"
import script from "./editWarning.vue?vue&type=script&lang=js&"
export * from "./editWarning.vue?vue&type=script&lang=js&"
import style0 from "./editWarning.vue?vue&type=style&index=0&id=c7c080f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c080f8",
  null
  
)

export default component.exports